// Dados centralizados da Clínica Habitus

export const CLINIC_INFO = {
  name: 'Clínica Habitus',
  phone: '(61) 94756-8717',
  phoneRaw: '5561947568717',
  callPhone: '(61) 99612-0137',
  callPhoneRaw: '5561996120137',
  email: 'contato@clinicahabitus.com.br',
  address: {
    street: 'SHCSW lotes 3/4/5, St. Sudoeste',
    complement: 'Centro Clínico Sudoeste Sala 101',
    city: 'Brasília - DF',
    zipCode: '70673-416',
  },
  foundingYear: 2016,
  /**
   * Identificação obrigatória de estabelecimento de saúde (Resolução CFM
   * 2.336/2023, art. 5º, I, e art. 6º): número de registro da clínica no CRM e
   * nome do Diretor Técnico-Médico com CRM, "em local visível" e na página
   * principal. É por isso que o rodapé exibe os dois em toda página. O Diretor
   * Técnico responde perante o CRM-DF por todo o conteúdo do site (art. 3º, II).
   */
  registroCrm: 'CRM-DF 5123',
  diretorTecnico: {
    nome: 'Dr. Mateus Soares',
    crm: 'CRM-DF 24705',
  },
  socialLinks: {
    instagram: 'https://www.instagram.com/clinicahabitus',
    facebook: 'https://www.facebook.com/clinicahabitus',
    /** Canal que hospeda os depoimentos embutidos na home. */
    youtube: 'https://www.youtube.com/@clinicahabitus',
    /**
     * Ficha da clínica no Doctoralia (318 avaliações em 09/2026). É a fonte
     * externa que Perplexity e Gemini mais citam sobre a clínica; entra no
     * `sameAs` para o grafo de entidade ligar as duas.
     */
    doctoralia: 'https://www.doctoralia.com.br/clinicas/clinica-habitus-saude-integrativa',
  },
  /**
   * Ficha da clínica no Google, pelo CID do Perfil da Empresa.
   *
   * Antes era `.../maps/place/Clínica+Habitus`, que é uma URL de BUSCA: abre o
   * que o Google achar para esse texto, não necessariamente esta clínica. O CID
   * aponta para a ficha exata e é o identificador estável do perfil —
   * `0xd9235b5a92ee79c0` em decimal, extraído da URL canônica do Maps
   * (ftid `0x935a306fe6738969:0xd9235b5a92ee79c0`, kgmid `/g/11cn_nt0yp`).
   */
  googleMapsCid: '15646449974985521600',
  googleMaps: 'https://maps.google.com/?cid=15646449974985521600',
  /**
   * Coordenadas da ficha no Google, não aproximadas.
   *
   * As antigas (-15.8014, -47.9296) erravam por ~300 m. A conta de Google Ads
   * já usava estas — é o centro do raio da campanha de Bioimpedância.
   */
  geo: { latitude: '-15.8021198', longitude: '-47.9323206' },
} as const;

export const WHATSAPP_LINK = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20como%20funcionam%20os%20atendimentos%20da%20Clínica%20Habitus!`;

export const WHATSAPP_LINK_MEDICINA_INTEGRATIVA = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20a%20consulta%20de%20medicina%20integrativa`;

export const WHATSAPP_LINK_SOROTERAPIA =`https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20os%20tratamentos%20de%20soroterapia`;

export const WHATSAPP_LINK_ENERGIA = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20os%20tratamentos%20de%20energia%20e%20foco`;

export const WHATSAPP_LINK_FIBROMIALGIA = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20os%20tratamentos%20de%20fibromialgia%20e%20artrite`;

export const WHATSAPP_LINK_BARIATRICA = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20os%20tratamentos%20de%20pós-bariátrica`;

export const WHATSAPP_LINK_EMAGRECA = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20os%20tratamentos%20de%20emagrecimento`;

export const WHATSAPP_LINK_OZONIOTERAPIA = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20os%20tratamentos%20de%20ozonioterapia`;

export const WHATSAPP_LINK_HIDROVITALIS = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20os%20tratamentos%20de%20Terapia%20Hidrovitalis`;

export const WHATSAPP_LINK_EQUILIBRA = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20os%20tratamentos%20de%20Plano%20Equilibra`;

export const WHATSAPP_LINK_REPOSICAO_HORMONAL = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20vim%20pelo%20site%20e%20gostaria%20de%20saber%20mais%20sobre%20os%20tratamentos%20de%20reposição%20hormonal`;

export const WHATSAPP_LINK_BIOIMPEDANCIA = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20gostaria%20de%20agendar%20o%20exame%20de%20bioimpedância%20InBody%20na%20Clínica%20Habitus.`;

export const WHATSAPP_LINK_ESTETICA_REGENERATIVA = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20vim%20pelo%20site%20e%20gostaria%20de%20agendar%20uma%20avaliação%20para%20LinearZ%20e%20Density%20na%20Clínica%20Habitus.`;

export const WHATSAPP_LINK_WELLNESS = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá!%20Vim%20pela%20página%20do%20Habitus%20Wellness%20e%20quero%20agendar%20meu%20Mapeamento%20Corporal.`;

export const WHATSAPP_LINK_INSTAGRAM = `https://api.whatsapp.com/send?phone=5561947568717&text=Olá,%20vim%20pelo%20link%20do%20Instagram%20e%20gostaria%20de%20saber%20como%20funcionam%20os%20atendimentos%20da%20Habitus!`;

/**
 * Dra. Diana Sevilha (estética regenerativa) — a /dradianasevilha usa o
 * WhatsApp DA CLÍNICA, como toda página do site: o contato passa pelo
 * ConectAI, que lê o marcador de campanha e alimenta a conversão offline do
 * Google Ads. (A /drclaudiomessias, que tinha número próprio fora do ConectAI,
 * saiu do site em 27/10/2026.)
 * Cada protocolo Regenera tem a própria frase: é ela que separa "flacidez" de
 * "lipedema" nos relatórios, porque o grupo de anúncio cai na âncora do
 * protocolo e o clique sai dali.
 */
const linkWhatsAppClinica = (mensagem: string) =>
  `https://api.whatsapp.com/send?phone=${CLINIC_INFO.phoneRaw}&text=${encodeURIComponent(mensagem)}`;

export const WHATSAPP_LINK_DRA_DIANA = linkWhatsAppClinica(
  'Olá! Vim pela página da Dra. Diana Sevilha e quero agendar uma avaliação de estética regenerativa.',
);

/** Um link por protocolo Regenera: a mensagem diz qual queixa a pessoa procurou. */
export const WHATSAPP_LINK_DRA_DIANA_POR_PROTOCOLO = {
  flacidez: linkWhatsAppClinica(
    'Olá! Vim pela página da Dra. Diana Sevilha e quero avaliar o tratamento de flacidez (Regenera Firme).',
  ),
  lipedema: linkWhatsAppClinica(
    'Olá! Vim pela página da Dra. Diana Sevilha e quero avaliar o tratamento de lipedema (Regenera Lipedema).',
  ),
  contorno: linkWhatsAppClinica(
    'Olá! Vim pela página da Dra. Diana Sevilha e quero avaliar gordura localizada ou celulite (Regenera Contorno).',
  ),
  face: linkWhatsAppClinica(
    'Olá! Vim pela página da Dra. Diana Sevilha e quero avaliar o rejuvenescimento facial regenerativo (Regenera Face).',
  ),
  capilar: linkWhatsAppClinica(
    'Olá! Vim pela página da Dra. Diana Sevilha e quero avaliar o tratamento de queda de cabelo (Regenera Capilar).',
  ),
  outros: linkWhatsAppClinica('Olá! Vim pela página da Dra. Diana Sevilha e quero avaliar um procedimento estético.'),
} as const;

export const WHATSAPP_LINK_NUTRI_LARISSA = linkWhatsAppClinica(
  'Olá! Vim pela página da nutricionista Larissa e quero agendar uma consulta de nutrição em saúde intestinal.',
);

/**
 * Link de WhatsApp de cada página, para o cabeçalho e a seção de contato.
 *
 * A mensagem pré-preenchida é o que identifica de qual página o contato veio —
 * é por ela que os relatórios separam a origem do lead. Antes, o botão
 * "Agendar" do topo e o da seção de contato usavam a mensagem genérica da home
 * em todas as páginas, então o contato vindo de uma página de tratamento
 * aparecia como se tivesse vindo da home.
 *
 * Rota não listada aqui cai no WHATSAPP_LINK genérico, que é o certo para a
 * home e para as páginas institucionais.
 */
/**
 * Perfil oficial no Instagram, com nome proprio.
 *
 * Aponta para `CLINIC_INFO.socialLinks.instagram` de proposito, em vez de
 * repetir a URL: a landing page do evento (/wellness) manda todo mundo pra ca
 * depois do cadastro e precisava de uma constante obvia, mas o dado continua
 * tendo uma unica fonte.
 */
export const INSTAGRAM_URL = CLINIC_INFO.socialLinks.instagram;

export const WHATSAPP_LINK_POR_ROTA: Record<string, string> = {
  '/medicina-integrativa': WHATSAPP_LINK_MEDICINA_INTEGRATIVA,
  '/soroterapia': WHATSAPP_LINK_SOROTERAPIA,
  '/energia-e-foco': WHATSAPP_LINK_ENERGIA,
  '/fibromialgia-e-artrite': WHATSAPP_LINK_FIBROMIALGIA,
  '/pos-bariatrica': WHATSAPP_LINK_BARIATRICA,
  '/emagreca-mais': WHATSAPP_LINK_EMAGRECA,
  '/ozonioterapia': WHATSAPP_LINK_OZONIOTERAPIA,
  '/hidrovitalis': WHATSAPP_LINK_HIDROVITALIS,
  '/reposicao-hormonal': WHATSAPP_LINK_REPOSICAO_HORMONAL,
  '/bioimpedancia': WHATSAPP_LINK_BIOIMPEDANCIA,
  '/estetica-regenerativa': WHATSAPP_LINK_ESTETICA_REGENERATIVA,
  // As rotas antigas /performa-mais e /performa+ redirecionam para cá — o
  // programa Performa+ virou Habitus Wellness em 31/07/2026.
  '/habitus-wellness': WHATSAPP_LINK_WELLNESS,
  '/dradianasevilha': WHATSAPP_LINK_DRA_DIANA,
  '/nutricionista-larissa': WHATSAPP_LINK_NUTRI_LARISSA,
};

// Ancoras com a barra na frente ('/#hero', nao '#hero'): o rodape aparece nas
// 56 paginas, e a versao sem barra so funcionava na home -- em /soroterapia
// esses links nao levavam a lugar nenhum.
export const QUICK_LINKS = [
  { label: 'Início', href: '/#hero' },
  { label: 'Depoimentos', href: '/#depoimentos' },
  { label: 'Estrutura', href: '/#estrutura' },
  { label: 'Equipe', href: '/#equipe' },
  { label: 'Diferenciais', href: '/#diferenciais' },
  { label: 'Perguntas Frequentes', href: '/faq' },
  { label: 'Sobre a Clínica', href: '/sobre-a-clinica' },
  { label: 'Blog', href: '/blog' },
  // As páginas de plano (/personalizado-para-voce e /plano-personalizado)
  // ficavam aqui; saíram em 22/09/2026 porque as rotas estão desativadas
  // (ver src/App.tsx).
] as const;

export const LEGAL_LINKS = [
  { label: 'Política de Privacidade', href: '/politica-de-privacidade' },
  { label: 'Termos de Uso', href: '/termo-de-uso' },
  { label: 'Política de Cookies', href: '/politica-de-cookies' },
] as const;
